import api from './api';

export type ProductStatus = 'active' | 'inactive' | 'pending_review' | 'rejected' | 'out_of_stock';

export interface AdminProductItem {
  _id: string;
  name: string;
  storeId?: any;
  accountTypeId?: any;
  price?: number;
  sku?: string;
  stock?: number;
  status: ProductStatus;
  isVerified?: boolean;
  createdAt?: string;
}

export interface ProductQuery {
  page?: number;
  limit?: number;
  search?: string;
  status?: ProductStatus;
  isVerified?: boolean;
  storeId?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

const productManagementService = {
  async getProducts(query: ProductQuery = {}): Promise<PaginatedResponse<AdminProductItem>> {
    const params: any = {};
    if (query.page) params.page = query.page;
    if (query.limit) params.limit = query.limit;
    if (query.search) params.search = query.search;
    if (query.status) params.status = query.status;
    if (typeof query.isVerified === 'boolean') params.isVerified = query.isVerified;
    if (query.storeId) params.storeId = query.storeId;

    const raw: any = await api.get<any>('/admin/products', { params } as any);

    // Normalize from { status, data: { products, pagination } }
    const products = raw?.products || raw?.data?.products || raw?.data?.items || [];
    const pagination = raw?.pagination || raw?.data?.pagination || {};

    const items: AdminProductItem[] = Array.isArray(products) ? products : [];
    const totalItems = Number(pagination.total || 0);
    const itemsPerPage = Number(pagination.limit || params.limit || 10);
    const currentPage = Number(pagination.page || params.page || 1);
    const totalPages = Number(pagination.pages || Math.ceil(totalItems / itemsPerPage) || 1);

    return {
      items,
      meta: {
        totalItems,
        itemCount: items.length,
        itemsPerPage,
        totalPages,
        currentPage,
      },
    };
  },

  async updateStatus(id: string, status: 'active' | 'inactive' | 'out_of_stock'): Promise<AdminProductItem> {
    const res = await api.patch<any>(`/admin/products/${id}/status`, { status });
    // res may be { status, data: { product } }
    if (res && res.status === 'success' && res.data?.product) return res.data.product as AdminProductItem;
    return res as AdminProductItem;
  },

  async getProductById(id: string): Promise<any> {
    const res: any = await api.get<any>(`/admin/products/${id}`);
    // normalize
    if (res?.data?.product) return res.data.product;
    if (res?.product) return res.product;
    return res;
  },
};

export default productManagementService;


